import { DeepCompareType } from "@website/utils/deep-compare/deep-compare.types";
import isEqual from "react-fast-compare";

export const deepCompare: DeepCompareType = isEqual;
